import React from "react"
import styled from "styled-components"
import { RegBody, SemiBdTitle3 } from "@sr/gatsby-theme-ui"
import { rem } from "polished"
import { media } from "@sr/common"

export interface ProductEntryFeaturesProps {
  features: {
    header: string
    featuresList: [
      {
        svg: {
          asset: {
            url: string
          }
        }
        snippet: string
      }
    ]
  }
}

const ProductEntryFeatures = ({ features }: ProductEntryFeaturesProps) => {
  if (!features?.featuresList?.length || !features?.header) return null
  return (
    <ProductFeaturesSectionStyled>
      <SemiBdTitle3>{features.header}</SemiBdTitle3>
      <div className="product-entry__features-container">
        {features.featuresList.map(({ snippet, svg }, index) => {
          return (
            <div className="product-entry__feature" key={index}>
              <img src={svg?.asset?.url || ""} alt="SVG Icon" />
              <RegBody className="product-entry__feature-text">
                {snippet}
              </RegBody>
            </div>
          )
        })}
      </div>
    </ProductFeaturesSectionStyled>
  )
}

export default ProductEntryFeatures

const ProductFeaturesSectionStyled = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: ${rem(120)};

  @media ${media.midUp} {
    margin-top: ${rem(136)};
  }

  @media ${media.stMidUp} {
    margin-top: ${rem(128)};
  }

  h2 {
    margin-bottom: 1rem;
  }

  .product-entry__features-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: ${rem(24)};
    max-width: ${rem(922)};
    margin: ${rem(72)} ${rem(16)} 0;

    @media ${media.midUp} {
      grid-gap: ${rem(40)} ${rem(88)};
    }

    @media ${media.stMidUp} {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .product-entry__feature {
    display: flex;
    gap: ${rem(16)};
    align-items: center;
    text-align: left;

    @media ${media.midUp} {
      gap: ${rem(32)};
    }

    .product-entry__feature-text {
      max-width: ${rem(332)};
    }
    img {
      height: ${rem(48)};
      width: ${rem(48)};

      @media ${media.midUp} {
        height: ${rem(72)};
        width: ${rem(72)};
      }
    }
  }
`
